import React from 'react';
import styles from './Features.module.css';

const Features = () => {
  const features = [
    {
      image: 'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=400&h=300&fit=crop',
      title: '500+ Photos Storage',
      description: 'Store and display hundreds of your favorite memories'
    },
    {
      image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=300&fit=crop',
      title: 'Fits Anywhere',
      description: 'Desk, fridge, bedside - place it wherever you want'
    },
    {
      image: '/assets/Battery.png',
      title: 'Year-Long Battery',
      description: 'Charge once and enjoy for over a year'
    }
  ];

  return (
    <section className={styles["features"]}>
      <div className={styles["features-container"]}>
        <div className={styles["features-grid"]}>
          {features.map((feature, index) => (
            <div key={index} className={styles["feature-card"]}>
              <div className={styles["feature-image-wrapper"]}>
                <img 
                  src={feature.image} 
                  alt={feature.title}
                  className={styles["feature-image"]}
                />
              </div>
              <h3 className={styles["feature-title"]}>{feature.title}</h3>
              <p className={styles["feature-description"]}>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;

